// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"dd118a8f","845":"fbaa1172"}[chunkId] + ".chunk.js";
};